import {createApi} from '@reduxjs/toolkit/query/react'
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {addBaseQueryParams, transformResponse, ULParams} from "@commons/utils/APIParams";
import {UnitaLocali} from "@commons/mapping/DataTablesSchema";
import {config} from "@commons/config.instance";

export const unitaLocaliApi = createApi({
    reducerPath: 'unitaLocaliApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    endpoints: (builder) => ({
        getUnitaLocali: builder.query<UnitaLocali, Partial<ULParams>>({
            query: (filter) => {

                let params: string[] = addBaseQueryParams(filter);
                if (filter.codAzienda) params.push('filter_codAzienda=' + filter.codAzienda);

                let url = `/azienda/${filter.idAzienda}/ul`;

                return url + `${params.length > 0 ? '?' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse
        }),

    }),
})
export const {useGetUnitaLocaliQuery} = unitaLocaliApi;